import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxMaskModule } from 'ngx-mask';

import { DragDropModule } from '@angular/cdk/drag-drop';
import { LayoutModule } from '@angular/cdk/layout';
import { registerLocaleData } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import localePt from '@angular/common/locales/pt';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, LOCALE_ID } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { PrivateModule } from './_pages/private/private.module';
import { AvatarComponent } from './_shared/components/avatar/avatar.component';
import { BadgeComponent } from './_shared/components/badge/badge.component';
import { BadgeContentComponent } from './_shared/components/badge/components/badge-content.component';
import { ButtonToggleGroupComponent } from './_shared/components/button-toggle/button-toggle-group.component';
import { ButtonToggleComponent } from './_shared/components/button-toggle/button-toggle.component';
import { ButtonToggleContentComponent } from './_shared/components/button-toggle/components/button-toggle-content.component';
import { ButtonComponent } from './_shared/components/button/button.component';
import { ButtonContentComponent } from './_shared/components/button/components/button-content.component';
import { CardBaseComponent } from './_shared/components/card/card-base/card-base.component';
import { CardGeneralComponent } from './_shared/components/card/card-general/card-general.component';
import { CardIndicatorsComponent } from './_shared/components/card/card-indicators/card-indicators.component';
import { CardIndicatorsChangeComponent } from './_shared/components/card/card-indicators/components/card-indicators-change.component';
import { CardIndicatorsIconComponent } from './_shared/components/card/card-indicators/components/card-indicators-icon.component';
import { CardIndicatorsLabelComponent } from './_shared/components/card/card-indicators/components/card-indicators-label.component';
import { CardIndicatorsValueComponent } from './_shared/components/card/card-indicators/components/card-indicators-value.component';
import { DtBodyTdComponent } from './_shared/components/datatable/components/dt-body/dt-body-td.component';
import { DtBodyTrComponent } from './_shared/components/datatable/components/dt-body/dt-body-tr.component';
import { DtBodyComponent } from './_shared/components/datatable/components/dt-body/dt-body.component';
import { DtColComponent } from './_shared/components/datatable/components/dt-colgroup/dt-col.component';
import { DtColgroupComponent } from './_shared/components/datatable/components/dt-colgroup/dt-colgroup.component';
import { DtPaginateFootComponent } from './_shared/components/datatable/components/dt-foot/dt-paginate-foot.component';
import { DtHeadThComponent } from './_shared/components/datatable/components/dt-head/dt-head-th.component';
import { DtHeadTrComponent } from './_shared/components/datatable/components/dt-head/dt-head-tr.component';
import { DtHeadComponent } from './_shared/components/datatable/components/dt-head/dt-head.component';
import { DatatableComponent } from './_shared/components/datatable/datatable.component';
import { CalendarPanelComponent } from './_shared/components/form-fields/datepicker/calendar-panel/calendar-panel.component';
import { DatepickerRangeComponent } from './_shared/components/form-fields/datepicker/datepicker-range/datepicker-range.component';
import { DatepickerSingleComponent } from './_shared/components/form-fields/datepicker/datepicker-single/datepicker-single.component';
import { InputGroupComponent } from './_shared/components/form-fields/input/input-group/input-group.component';
import { InputComponent } from './_shared/components/form-fields/input/input.component';
import { OptionComponent } from './_shared/components/form-fields/select/option.component';
import { SelectTriggerDirective } from './_shared/components/form-fields/select/select-trigger.directive';
import { SelectComponent } from './_shared/components/form-fields/select/select.component';
import { FormFieldComponent } from './_shared/components/form-fields/shared/form-field/form-field.component';
import { SelectAccountComponent } from './_shared/components/select-account/select-account.component';
import { SkeletonLoaderComponent } from './_shared/components/skeleton-loader/skeleton-loader.component';
import { TabComponent } from './_shared/components/tabs/components/tab/tab.component';
import { TabsComponent } from './_shared/components/tabs/tabs.component';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AdminModule } from './modules/admin/admin.module';
import { AdministrativeAccountsListComponent } from './modules/admin/pages/accounts-list/administrative-accounts-list.component';
import { PlanSelectionModalComponent } from './modules/admin/pages/accounts-list/modals/plan-selection-modal/plan-selection-modal.component';
import { AdministrativeAccountsUsersReportComponent } from './modules/admin/pages/accounts-users-report/accounts-users-report.component';
import { AdministrativeConsolidatedSchedulesReportComponent } from './modules/admin/pages/consolidated-schedules-report/consolidated-schedules-report.component';
import { AvailableConsolidatedSchedulesFiltersModalComponent } from './modules/admin/pages/consolidated-schedules-report/modals/available-filters/available-filters.modal';
import { InaptTransferModalComponent } from './modules/admin/pages/consolidated-schedules-report/modals/inapt-transfer/inapt-transfer.modal';
import { PaidConsolidatedSchedulesFiltersModalComponent } from './modules/admin/pages/consolidated-schedules-report/modals/paid-filters/paid-filters.modal';
import { TransferConfirmationModalComponent } from './modules/admin/pages/consolidated-schedules-report/modals/transfer-confirmation/transfer-confirmation.modal';
import { AdministrativeIndicationsFinancialComponent } from './modules/admin/pages/indication-financial/indication-financial.component';
import { AdministrativeIndicationsComponent } from './modules/admin/pages/indications-report/indications-report.component';
import { AttachReportModalComponent } from './modules/admin/pages/indications-report/modals/attach-report/attach-report.modal';
import { ScheduleDocumentsListComponent } from './modules/admin/pages/indications-report/modals/attach-report/schedule-documents-list/schedule-documents-list.component';
import { ScheduleReportPanelComponent } from './modules/admin/pages/indications-report/modals/attach-report/schedule-report-panel/schedule-report-panel.component';
import { IndicationsReportFiltersModalComponent } from './modules/admin/pages/indications-report/modals/indications-report-filters/indications-report-filters.modal';
import { addSpecialtyChangePricesModal } from './modules/admin/pages/procedure-plans/modal/add-specialty-change-prices-modal.component';
import { CreateProcedureModalComponent } from './modules/admin/pages/procedure-plans/modal/create-procedure-modal.component';
import { DeleteInactiveActiveModalComponent } from './modules/admin/pages/procedure-plans/modal/delete-specialty-inactive-active-procedure-modal.component';
import { ProcedurePlansComponent } from './modules/admin/pages/procedure-plans/procedure-plans.component';
import { AddSpecialtyModalComponent } from './modules/admin/pages/specialties/add-specialty-modal/add-specialty-modal.component';
import { SpecialtiesComponent } from './modules/admin/pages/specialties/specialties.component';
import { DoctorReviewsModalComponent } from './modules/indication/components/modals/doctor-reviews-modal/doctor-reviews-modal.component';
import { SharedModule } from './modules/shared/shared.module';
import { TechnicalAssistanceModule } from './modules/technical-assistance/technical-assistance.module';
import { IndicationAnalyticsComponent } from './pages/administrative/indication-analytics/indication-analytics.component';
import { BetaPaymentComponent } from './pages/beta-payment/beta-payment.component';
import { CasesComponent } from './pages/cases/cases.component';
import { ArchivedCasesComponent } from './pages/cases/components/archived-cases/archived-cases.component';
import { HistoryCasesComponent } from './pages/cases/components/history-cases/history-cases.component';
import { LeadDetailsModalComponent } from './pages/cases/components/lead-details-modal/lead-details-modal.component';
import { KanbanCardComponent } from './pages/cases/components/my-cases/kanban-card/kanban-card.component';
import { KanbanColumnComponent } from './pages/cases/components/my-cases/kanban-column/kanban-column.component';
import { KanbanGraphicsComponent } from './pages/cases/components/my-cases/kanban-graphics/kanban-graphics.component';
import { MyCasesModalComponent } from './pages/cases/components/my-cases/modal/my-cases-modal.component';
import { MyCasesComponent } from './pages/cases/components/my-cases/my-cases.component';
import { LeadStatusPipe } from './pages/cases/components/my-cases/pipes/lead-status.pipe';
import { TimeAgoPipe } from './pages/cases/components/my-cases/pipes/time-ago.pipe';
import { StatusConfirmationComponent } from './pages/cases/components/my-cases/status-confirmation/status-confirmation.component';
import { CompleteRegistrationComponent } from './pages/complete-registration/complete-registration.component';
import { ContractorComponent } from './pages/contractor/contractor.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { DoctorNpsModalComponent } from './pages/indications/doctor-nps-modal/doctor-nps-modal.component';
import { InvitationComponent } from './pages/invitation/invitation.component';
import { InvoiceListComponent } from './pages/invoice/invoice-list.component';
import { InvoicesComponent } from './pages/invoices/invoices.component';
import { LoginComponent } from './pages/login/login.component';
import { PatientsComponent } from './pages/patients/patients.component';
import { CreatePriceModalComponent } from './pages/plan-prices/modals/create-price-modal.component';
import { PlanPricesComponent } from './pages/plan-prices/plan-prices.component';
import { CreatePlanModalComponent } from './pages/plans/modals/create-plan-modal.component';
import { EditPlanModalComponent } from './pages/plans/modals/edit-plan-modal.component';
import { InactivePlanPricesModalComponent } from './pages/plans/modals/inactive-plan-prices-modal.component';
import { PlansComponent } from './pages/plans/plans.component';
import { UserRegisterComponent } from './pages/public/user-register/user-register.component';
import { AccountRegisterSuccessComponent } from './pages/public/views/account-register-success/account-register-success.component';
import { AccountRegisterComponent } from './pages/public/views/account-register/account-register.component';
import { RegisterComponent } from './pages/register/register.component';
import { AccountsCsvReportComponent } from './pages/reports/accounts-csv-report/accounts-csv-report.component';
import { DelayedAttendanceReportComponent } from './pages/reports/delayed-attendance-report/delayed-attendance-report.component';
import { DelayedReportFiltersModalComponent } from './pages/reports/delayed-attendance-report/modals/delayed-report-filters/delayed-report-filters.modal';
import { IndicationsByDoctorComponent } from './pages/reports/nps/indications-by-doctor/indications-by-doctor.component';
import { NpsAverageComponent } from './pages/reports/nps/nps-average/nps-average.component';
import { SubscriptionReportComponent } from './pages/reports/users/subscription-report.component';
import { SignatureComponent } from './pages/signature/signature.component';
import { UserListComponent } from './pages/users/user-list/user-list.component';
import { UserComponent } from './pages/users/user/user.component';
import { UsersComponent } from './pages/users/users.component';
import { WalletModalComponent } from './pages/wallet/modals/wallet-modal/wallet-modal.component';
import { WalletComponent } from './pages/wallet/wallet.component';
import { ErrorInterceptor } from './services/Interceptor';
import { CardCasesComponent } from './shared/components/card-cases/table/card-cases.component';
import { CardDialogComponent } from './shared/components/card-dialog/card-dialog.component';
import { ConfirmDialogComponent } from './shared/components/ConfirmDialogComponent';
import { DoctorSelectAutocompleteComponent } from './shared/components/doctor-select-autocomplete/doctor-select-autocomplete.component';
import { ImageCropperModule } from './shared/components/image-cropper/image-cropper.module';
import { ListPlanConsultationComponent } from './shared/components/list-plan-consultation/list-plan-consultation';
import { LoadingComponent } from './shared/components/loading/loading.component';
import { PricingCardComponent } from './shared/components/pricing-card/pricing-card.component';
import { TableComponent } from './shared/components/table/table.component';
import { UiAddPatientComponent } from './shared/components/ui-add-patient/ui-add-patient.component';
import { UiChangePasswordComponent } from './shared/components/ui-change-password/ui-change-password.component';
import { UiConfirmationDialogComponent } from './shared/components/ui-confirmation-dialog/ui-confirmation-dialog.component';
import { UiUploadComponent } from './shared/components/ui-upload/ui-upload.component';
import { LocalFontAwesome } from './shared/modules/fontawesome/fontawesome.module';
import { LocalMaterialModule } from './shared/modules/material/material.module';
import { ConcatPipe } from './shared/pipes/concat.pipe';
import { CurrencyPipe } from './shared/pipes/currency.pipe';
import { DatePipe } from './shared/pipes/date.pipe';
import { DateBRPlanPricePipe } from './shared/pipes/DateBRPlanPricePipe.component';
import { InitialLettersPipe } from './shared/pipes/initial-letters.pipe';
import { PartialPipe } from './shared/pipes/partial.pipe';
import { SafePipe } from './shared/pipes/safe.pipe';
import { timerIndicationPipe } from './shared/pipes/timerIndication.pipe';
// Formatação de data padrão Brasileiro

import { WhatsappPhonePipe } from './shared/pipes/whatsapp-phone.pipe';

registerLocaleData(localePt);

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    InitialLettersPipe,
    LoadingComponent,
    DatePipe,
    ConcatPipe,
    PartialPipe,
    RegisterComponent,
    ForgotPasswordComponent,
    PatientsComponent,
    SignatureComponent,
    ContractorComponent,
    InvoicesComponent,
    UsersComponent,
    CardDialogComponent,
    UiUploadComponent,
    UserListComponent,
    UserComponent,
    InvitationComponent,
    CompleteRegistrationComponent,
    SafePipe,
    UiAddPatientComponent,
    UiConfirmationDialogComponent,
    UiChangePasswordComponent,
    PricingCardComponent,
    DoctorNpsModalComponent,
    IndicationsByDoctorComponent,
    DoctorSelectAutocompleteComponent,
    SpecialtiesComponent,
    AddSpecialtyModalComponent,
    NpsAverageComponent,
    SubscriptionReportComponent,
    DelayedAttendanceReportComponent,
    BetaPaymentComponent,
    WalletComponent,
    WalletModalComponent,
    PlansComponent,
    CreatePlanModalComponent,
    PlanPricesComponent,
    CreatePriceModalComponent,
    EditPlanModalComponent,
    DateBRPlanPricePipe,
    InactivePlanPricesModalComponent,
    ConfirmDialogComponent,
    ProcedurePlansComponent,
    DeleteInactiveActiveModalComponent,
    addSpecialtyChangePricesModal,
    CreateProcedureModalComponent,
    timerIndicationPipe,
    UserRegisterComponent,
    AccountRegisterComponent,
    AccountRegisterSuccessComponent,
    ListPlanConsultationComponent,
    CasesComponent,
    MyCasesComponent,
    MyCasesModalComponent,
    LeadDetailsModalComponent,
    ArchivedCasesComponent,
    InvoiceListComponent,
    AccountsCsvReportComponent,
    IndicationAnalyticsComponent,
    DoctorReviewsModalComponent,
    AdministrativeAccountsListComponent,
    PlanSelectionModalComponent,
    AdministrativeIndicationsComponent,
    IndicationsReportFiltersModalComponent,
    AdministrativeIndicationsFinancialComponent,
    AttachReportModalComponent,
    ScheduleReportPanelComponent,
    ScheduleDocumentsListComponent,
    AdministrativeAccountsUsersReportComponent,
    AdministrativeConsolidatedSchedulesReportComponent,
    TransferConfirmationModalComponent,
    InaptTransferModalComponent,
    PaidConsolidatedSchedulesFiltersModalComponent,
    AvailableConsolidatedSchedulesFiltersModalComponent,
    DelayedReportFiltersModalComponent,
    KanbanColumnComponent,
    KanbanCardComponent,
    StatusConfirmationComponent,
    LeadStatusPipe,
    TimeAgoPipe,
    TableComponent,
    CardCasesComponent,
    HistoryCasesComponent,
    KanbanGraphicsComponent,
    WhatsappPhonePipe,
  ],
  imports: [
    BrowserModule,
    InfiniteScrollModule,
    AppRoutingModule,
    LocalMaterialModule,
    LocalFontAwesome,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskModule.forRoot(),
    LayoutModule,
    HttpClientModule,
    ImageCropperModule,
    MatTableModule,
    MatToolbarModule,
    MatButtonModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatAutocompleteModule,
    SharedModule,
    AdminModule,
    TechnicalAssistanceModule,
    DragDropModule,
    CardBaseComponent,
    CardIndicatorsComponent,
    CardIndicatorsIconComponent,
    CardIndicatorsValueComponent,
    CardIndicatorsLabelComponent,
    CardIndicatorsChangeComponent,
    DatatableComponent,
    DtHeadComponent,
    DtHeadThComponent,
    DtHeadTrComponent,
    DtBodyComponent,
    DtBodyTrComponent,
    DtBodyTdComponent,
    DtPaginateFootComponent,
    DtColgroupComponent,
    DtColComponent,
    SkeletonLoaderComponent,
    AvatarComponent,
    ButtonComponent,
    ButtonContentComponent,
    InputComponent,
    InputGroupComponent,
    FormFieldComponent,
    PrivateModule,
    SelectComponent,
    OptionComponent,
    SelectTriggerDirective,
    SelectAccountComponent,
    CalendarPanelComponent,
    DatepickerSingleComponent,
    DatepickerRangeComponent,
    BadgeComponent,
    BadgeContentComponent,
    TabsComponent,
    TabComponent,
    ButtonToggleComponent,
    ButtonToggleContentComponent,
    ButtonToggleGroupComponent,
    CardGeneralComponent,
    ButtonToggleComponent,
    ButtonToggleGroupComponent,
    TabsComponent,
    TabComponent,
    CurrencyPipe,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    SafePipe,
    { provide: LOCALE_ID, useValue: 'pt-BR' },
  ],
  entryComponents: [CardDialogComponent, UserComponent],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {
  constructor() {}
}
